__turbopack_context__.v({
  "gridContainer": "hero-grid-module__oIzv-W__gridContainer",
  "mainGrid": "hero-grid-module__oIzv-W__mainGrid",
  "tile": "hero-grid-module__oIzv-W__tile",
});
